<template>
  <div>
    <Head title="Benutzer*innen"/>
    <h1 class="h1">Benutzer*innen</h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="p-4">
        <div v-if="exam">
          <h2>{{ exam.name }}</h2>
          <ul>
            <li v-for="question in exam.questions">{{ question.text }} <small>{{ question.type }}</small></li>
          </ul>
        </div>
        <div class="d-block">
          <loading-button :loading="isLoading" class="btn-primary inline-block mt-2" @click="submit()">Test
          </loading-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '../../Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
    Head,
  },

  layout: Layout,

  props: {},

  data() {
    return {
      isLoading: false,
      exam: null,
    }
  },

  methods: {
    submit() {
      let data = {

      }
      $axios.post('/api/devtest', data )
          .then((response) => {
            console.log(response.data)
            this.exam = response.data
          })
          .catch(error => {
            console.log(error)
          })
    },
  },
}
</script>
